import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { canAccessPlanner } from "@ramudden/models/user";
import { AuthenticationService } from "../services/authentication.service";
import { GlobalStateService } from "../services/global-state.service";

/**
 * Keeps the whole Planner module out of reach of organizations that do not use it, so a bookmark or a hand-typed
 * URL cannot land on a module whose navigation entry is hidden. Denied users are sent to their first available
 * screen, the same way authorizationGuard resolves a refusal.
 */
export const plannerAccessGuard: CanActivateFn = (): boolean | UrlTree => {
    const router = inject(Router);
    const globalStateService = inject(GlobalStateService);
    const authenticationService = inject(AuthenticationService);

    if (canAccessPlanner(globalStateService.getAuthorizationInfo()?.user)) {
        return true;
    }

    const availableLink = authenticationService
        .getNavigationLinks(globalStateService.getCurrentRights())
        .takeFirstOrDefault();
    if (!availableLink) {
        return false;
    }

    return router.parseUrl(availableLink.route);
};
